export default {
  setQuizzes(state, quizzes) {
    state.quizzes = quizzes;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
